import { useEffect, useState } from 'react';

import { bilingualError } from '../index';
import styles from '../index.module.less';

import { Button, Card, Col, Divider, Logo, Row } from '$HVUI';
import { useFetch } from '$Hooks';

const Refresh = ({ token }) => {
    let [error, setError] = useState();
    let [refreshed, setRefreshed] = useState();

    const { data, post, response } = useFetch(
        '/api/v2/results/token-results/refresh/'
    );

    useEffect(() => {
        // Wait until it's completed at least once
        if (!response.status) return;
        if (!data || !data.token) {
            setError(bilingualError({}));
            return;
        }
        setRefreshed(true);
    }, [response.status]);

    const refreshToken = () => {
        return post({
            token
        });
    };

    const content = () => {
        if (error) {
            return <Col>{error}</Col>;
        }
        if (refreshed) {
            return (
                <Col>
                    <p>
                        A new link has been sent to you. Please allow up to five
                        minutes for it to arrive.
                    </p>
                    <p lang="es">
                        Se le ha enviado un nuevo enlace. Por favor permítelo
                        hasta cinco minutos para llegar.
                    </p>
                </Col>
            );
        }
        return (
            <>
                <Col>
                    <p>
                        Your link has expired. Click the button below to have a
                        new link sent to you.
                    </p>
                    <p lang="es">
                        Su enlace se expiró. Haga clic en el butón de abajo para
                        enviarse un nuevo enlace.
                    </p>
                </Col>
                <Col>
                    <Button
                        id="refresh-token"
                        style={{
                            display: 'block',
                            margin: '24px auto'
                        }}
                        text="Send new link / Enviar nuevo enlace"
                        level="primary"
                        onClick={refreshToken}
                    />
                </Col>
            </>
        );
    };
    return (
        <div className={styles['wrapper']}>
            <Card className={styles['card']} style={{ maxWidth: '600px' }}>
                <Row>
                    <Col span={12}>
                        <Logo style={{ width: '100%' }} />
                    </Col>
                    <Col span={12} />
                </Row>
                <Divider />
                <Row justify="center">{content()}</Row>
            </Card>
        </div>
    );
};

export default Refresh;
